<template>    
     <BaseModal
        :id="'static'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_prevent()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'


export default {

    name:   'FormModal',
    props: [
        'title',
        'rest_api',
        'parent',
        'parent_id',
        'notyf',
        'array_options',
        'breadcrumb',
  ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
        }
    },

    watch: {
        parent(val)
        {
            this.form_backup.time_start = val.start_time
            this.form_backup.time_end   = val.end_time

            this.form_data.time_start = val.start_time
            this.form_data.time_end   = val.end_time
        },
        async 'form_data.shift_id' (val)
        {
            let found_shift = this.array_options.shift_id.find(shift => val === shift.id);
            if(found_shift)
            {
                this.form_data.time_start = found_shift.start_time
                this.form_data.time_end = found_shift.end_time
            }
        }

    } ,

    methods:{

        form_submit_prevent()
        {
            if(this.form_data.length === '' || this.form_data.length === 0)
            {
                this.notyf.error("Length cannot be empty or zero")
                return false
            }
            this.form_submit()
        }

    },

    mounted()
    {
    }
    
}
</script>